const mimiArr = [
  {
    "type": "miniprogram",
    "name": "我的首页",
    "url": "http://www.soso.com/",
    "appid": "wxed28bb65a2faa156",
    "pagepath": "pages/index/index"
  },
  {
    "type": "miniprogram",
    "name": "领券中心",
    "url":"http://www.soso.com/",
    "appid": "wxed28bb65a2faa156",
    "pagepath": "home/coupon_center/coupon_center"
  },
  {
    "type": "miniprogram",
    "name": "充值中心",
    "url":"http://www.soso.com/",
    "appid": "wxed28bb65a2faa156",
    "pagepath": "userfeatures/refillcard/refillcard"
  },
  {
    "type": "miniprogram",
    "name": "门店列表",
    "url":"http://www.soso.com/",
    "appid": "wxed28bb65a2faa156",
    "pagepath": "home/oilstorelist/oilstorelist"
  },
  {
    "type": "miniprogram",
    "name": "积分商城",
    "url":"http://www.soso.com/",
    "appid": "wxed28bb65a2faa156",
    "pagepath": "home/integral/integral"
  }
]

const mimiArr_2 = [
  {
    "type": "miniprogram",
    "name": "我的首页",
    "url": "http://www.soso.com/",
    "appid": "wxed28bb65a2faa156",
    "pagepath": "pages/index/index"
  },
  {
    "type": "miniprogram",
    "name": "领券中心",
    "url":"http://www.soso.com/",
    "appid": "wxed28bb65a2faa156",
    "pagepath": "home/coupon_center/coupon_center"
  },
  {
    "type": "miniprogram",
    "name": "充值中心",
    "url":"http://www.soso.com/",
    "appid": "wxed28bb65a2faa156",
    "pagepath": "userfeatures/refillcard/refillcard"
  },
  {
    "type": "miniprogram",
    "name": "门店列表",
    "url":"http://www.soso.com/",
    "appid": "wxed28bb65a2faa156",
    "pagepath": "home/oilstorelist/oilstorelist"
  },
  {
    "type": "miniprogram",
    "name": "切换小程序",
    "url": "http://www.soso.com/",
    "appid": "wxed28bb65a2faa156",
    "pagepath": "pages/mini_change/mini_change"
  },
  {
    "type": "miniprogram",
    "name": "积分商城",
    "url":"http://www.soso.com/",
    "appid": "wxed28bb65a2faa156",
    "pagepath": "home/integral/integral"
  },
]

export { mimiArr, mimiArr_2 };